import * as Yup from 'yup'

const consignmentInboundRequestConfirmFormSchema = Yup.object().shape({
  shipping_method     : Yup.string(),
  pickup_vehicle_type : Yup.string().when('shipping_method', {
    is   : (shipping_method) => shipping_method === 'pickup',
    then : Yup.string().required('Required')
  }),
  scheduled_at: Yup.string()
})

export default consignmentInboundRequestConfirmFormSchema
